import { render, staticRenderFns } from "./icon-arrow-down.vue?vue&type=template&id=1b0c627c"
import script from "./icon-arrow-down.vue?vue&type=script&lang=ts"
export * from "./icon-arrow-down.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports